<template>
  <div>
    <div class="col-lg-12">
      <Chat
        :participants="participants"
        :myself="myself"
        :messages="messages"
        :chat-title="chatTitle"
        :placeholder="placeholder"
        :colors="colors"
        :border-style="borderStyle"
        :hide-close-button="hideCloseButton"
        :close-button-icon-size="closeButtonIconSize"
        :submit-icon-size="submitIconSize"
        :async-mode="asyncMode"
        :timestamp-config="timestampConfig"
        @onClose="onClose"
        @onMessageSubmit="onMessageSubmit"
      />
    </div>
  </div>
</template>

<script>

import { Chat } from 'vue-quick-chat';
import firebase from '../../firebase';
import '../../assets/css/vue-quick-chat-custom.min.css';

export default {
  name: 'BookingChat',

  components: {
    Chat,
  },

  props: {
    booking: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      message_input: '',
      conversation: null,

      visible: true,
      participants: [
        {
          name: '',
          id: 1,
        },
      ],
      myself: {
        name: '',
        id: 2,
      },
      messages: [

      ],
      chatTitle: 'Chat',
      placeholder: this.$t('lang.bookings.chat_placeholder'),
      colors: {
        header: {
          bg: '#ff1460',
          text: '#fff',
        },
        message: {
          myself: {
            bg: '#c1c1c1',
            text: '#000000',
          },
          others: {
            bg: '#ff1460',
            text: '#fff',
          },
          messagesDisplay: {
            bg: '#f7f3f3',
          },
        },
        submitIcon: '#ff1460',
      },
      borderStyle: {
        topLeft: '10px',
        topRight: '10px',
        bottomLeft: '10px',
        bottomRight: '10px',
      },
      hideCloseButton: true,
      submitIconSize: 20,
      closeButtonIconSize: '20',
      asyncMode: false,
      toLoad: [
      ],
      timestampConfig: {
        format: 'dd/M HH:mm',
        relative: false,
      },

    };
  },

  created() {
    if (this.booking.chat_unique_key) {
      const context = this;

      firebase.database().ref(`messages/${this.booking.chat_unique_key}`).on('child_added', (snapshot) => {
        const messageObject = snapshot.val();
        const messageElement = context.inBookingMessage(messageObject.senderType,
          messageObject.message,
          messageObject.date);

        if (messageElement != null) {
          context.messages.push(messageElement);
        }
      });
    }
  },

  methods: {
    newMessage(chatKey, messageContent) {
      const message = messageContent.content;
      const newMessageKey = firebase.database().ref(`messages/${chatKey}/`).push({
        senderType: 'user',
        message,
        date: Date.now(),
      }).key;

      firebase.database().ref(`chats/${chatKey}/lastMessage`).set(newMessageKey);
    },

    inBookingMessage(senderType, message, messageTimeStamps) {
      let myself;
      let participantId;

      if (senderType === 'user') {
        myself = true;
        participantId = 2;
      } else {
        myself = false;
        participantId = 1;
      }
      const messageTime = new Date(messageTimeStamps);

      let timestamp = null;

      timestamp = {
        year: messageTime.getFullYear(),
        month: messageTime.getMonth(),
        day: messageTime.getDate(),
        hour: messageTime.getHours(),
        minute: messageTime.getMinutes(),
        second: messageTime.getSeconds(),
        millisecond: messageTime.getMilliseconds(),
      };

      const messageElement = {
        content: message,
        myself,
        participantId,
        timestamp,
      };
      return messageElement;
    },
    onMessageSubmit(message) {
      this.newMessage(this.booking.chat_unique_key, message);
    },
    onClose() {
      this.visible = false;
    },

  },
};
</script>
